module.exports = __webpack_public_path__ + "img/picture_grey.08e1d1d2.svg";